const patternEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,9}$/;
const patternPassword = {
    upper_lower_number: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)(?=.*[@_!$%^&#*)(.-]).{8,32}.*$/,
};
const patternDate = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
const patternFloatValue = /^-?(?:\d+|(\d*\.\d\d|\d*\.\d))$/;
const patternTimeValue = /^(1[012]|[1-9]):[0-5][0-9] ?(am|pm)$/i;
const patternYear = /^[0-9]{4}$/;
const patternNumericData = /^[0-9]{4,6}$/;
const patternNumericValue = /^[0-9]{1,8}$/;
const imageExtention = /([a-zA-Z0-9\s_\\.\-():])+(.jpeg|.jpg|.png)$/;
const csvExtention = /([a-zA-Z0-9\s_\\.\-():])+(.csv)$/;
const patternNumericTenDigitsValue = /^[02-9][0-9]{9}$/;
const patternPhone = /^\(?([2-9][0-8][0-9])\)?([2-9][0-9]{2})([0-9]{4})$/;
const patternGetNameExtension = /(?:\.([^.]+))?$/;
const mimeTypes = {
    csv: "text/csv",
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    avif: "image/avif",
    svg: "image/svg+xml",
    webp: "image/webp",
    xls: [
        "application/vnd.openxmlformats-",
        "application/wps-office.xlsx",
        "application/vnd.ms-excel",
        "officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    xlsx: [
        "application/vnd.openxmlformats-",
        "application/wps-office.xlsx",
        "application/vnd.ms-excel",
        "officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    images: ["image/jpeg", "image/png", "image/gif", "image/avif", "image/svg+xml", "image/webp"],
    documents: [
        "text/plain",
        "text/csv",
        "application/pdf",
        "application/wps-office.xlsx",
        "application/vnd.amazon.ebook",
        "application/msword",
        "application/vnd.openxmlformats-",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.text",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-",
        "application/vnd.rar",
        "application/rtf",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-",
        "application/zip",
        "application/x-zip-compressed",
        "application/gzip",
        "officedocument.spreadsheetml.sheet",
        "officedocument.presentationml.presentation",
        "officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
};
const validateObjectNull = {
  hasLowerUpperCaseAndNumberSpecialChar: true,
  hasLength: true,
  hasRepeatedOrSequential: true,
  hasUsername: true,
  hasLast6UsedPassword: true,
  hasConfirmPassword: true
}; 
const validatePassword = (password, username, lastUsedPasswords) => {
  // Criteria 1: Minimum length of 8 characters
  if (password.length < 8) {
    return "Password must be at least 8 characters long.";
  }

  // Criteria 2: At least one character of each group
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (!hasLowerCase || !hasUpperCase || !hasNumber || !hasSpecialChar) {
    return "Password must include lower case, upper case, number, and special character.";
  }

  // Criteria 3: Not allow 3 repeated or sequential characters
  const repeatedOrSequential = /(.)\1\1|012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba|210|321|432|543|654|765|876|987|098/i;
  if (repeatedOrSequential.test(password)) {
    return "Password cannot have 3 repeated or sequential characters.";
  }

  // Criteria 4: Not allow portions of the username
  const lowerUsername = username.toLowerCase();
  const lowerPassword = password.toLowerCase();
  for (let i = 0; i <= lowerUsername.length - 3; i++) {
    if (lowerPassword.includes(lowerUsername.substring(i, i + 3))) {
      return "Password cannot contain portions of the username.";
    }
  }

  // Criteria 5: Not allow the password to be the same from the last 6 used passwords
  if (lastUsedPasswords.includes(password)) {
    return "Password cannot be the same as the last 6 used passwords.";
  }

  return null; // No errors, password is valid
};

const CLOTHING_SIZES = [
    {value: 'M - XS', label: 'M - XS'},
    {value: 'M - S', label: 'M - S'},
    {value: 'M - MED', label: 'M - MED'},
    {value: 'M - L', label: 'M - L'},
    {value: 'M - XL', label: 'M - XL'},
    {value: 'M - 2XL', label: 'M - 2XL'},
    {value: 'M - 3XL', label: 'M - 3XL'},
    {value: 'M - 4XL', label: 'M - 4XL'},
    {value: 'M - 5XL', label: 'M - 5XL'},
    {value: 'W - XS', label: 'W - XS'},
    {value: 'W - S', label: 'W - S'},
    {value: 'W - MED', label: 'W - MED'},
    {value: 'W - L', label: 'W - L'},
    {value: 'W - XL', label: 'W - XL'},
    {value: 'W - 2XL', label: 'W - 2XL'},
];

const SHOW_SIZES = [
    {value: 'M - US 4/EU 37', label: 'M - US 4/EU 37'},
    {value: 'M - US 4.5/EU 37', label: 'M - US 4.5/EU 37'},
    {value: 'M - US 5/EU 38', label: 'M - US 5/EU 38'},
    {value: 'M - US 5.5/EU 38', label: 'M - US 5.5/EU 38'},
    {value: 'M - US 6/EU 39', label: 'M - US 6/EU 39'},
    {value: 'M - US 6.5/EU 39', label: 'M - US 6.5/EU 39'},
    {value: 'M - US 7/EU 40', label: 'M - US 7/EU 40'},
    {value: 'M - US 7.5/EU 40', label: 'M - US 7.5/EU 40'},
    {value: 'M - US 8/EU 41', label: 'M - US 8/EU 41'},
    {value: 'M - US 8.5/EU 41', label: 'M - US 8.5/EU 41'},
    {value: 'M - US 9/EU 42', label: 'M - US 9/EU 42'},
    {value: 'M - US 9.5/EU 42', label: 'M - US 9.5/EU 42'},
    {value: 'M - US 10/EU 43', label: 'M - US 10/EU 43'},
    {value: 'M - US 10.5/EU 43', label: 'M - US 10.5/EU 43'},
    {value: 'M - US 11/EU 44', label: 'M - US 11/EU 44'},
    {value: 'M - US 11.5/EU 44', label: 'M - US 11.5/EU 44'},
    {value: 'M - US 12/EU 45', label: 'M - US 12/EU 45'},
    {value: 'M - US 12.5/EU 45', label: 'M - US 12.5/EU 45'},
    {value: 'M - US 13/EU 46', label: 'M - US 13/EU 46'},
    {value: 'M - US 13.5/EU 46', label: 'M - US 13.5/EU 46'},
    {value: 'M - US 14/EU 47', label: 'M - US 14/EU 47'},
    {value: 'M - US 14.5/EU 47', label: 'M - US 14.5/EU 47'},
    {value: 'M - US 15/EU 48', label: 'M - US 15/EU 48'},
    {value: 'W - US 5/EU 36', label: 'W - US 5/EU 36'},
    {value: 'W - US 5.5/EU 36', label: 'W - US 5.5/EU 36'},
    {value: 'W - US 6/EU 37', label: 'W - US 6/EU 37'},
    {value: 'W - US 6.5/EU 37', label: 'W - US 6.5/EU 37'},
    {value: 'W - US 7/EU38', label: 'W - US 7/EU38'},
    {value: 'W - US 7.5/EU 38', label: 'W - US 7.5/EU 38'},
    {value: 'W - US 8/EU 39', label: 'W - US 8/EU 39'},
    {value: 'W - US 8.5/EU 39', label: 'W - US 8.5/EU 39'},
    {value: 'W - US 9/EU 40', label: 'W - US 9/EU 40'},
    {value: 'W - US 9.5/EU 40', label: 'W - US 9.5/EU 40'},
    {value: 'W - US 10/EU 41', label: 'W - US 10/EU 41'},
    {value: 'W - US 10.5/EU 41', label: 'W - US 10.5/EU 41'},
    {value: 'W - US 11/EU 42', label: 'W - US 11/EU 42'},
    {value: 'W - US 11.5/EU 42', label: 'W - US 11.5/EU 42'},
    {value: 'W - US 12/EU 43', label: 'W - US 12/EU 43'},
    {value: 'W - US 12.5/EU 43', label: 'W - US 12.5/EU 43'},
    {value: 'W - US 13/EU 44', label: 'W - US 13/EU 44'},
    {value: 'W - US 13.5/EU 44', label: 'W - US 13.5/EU 44'},
];

const USA_STATES = [
    {value: "AL", label: "AL"},
    {value: "AK", label: "AK"},
    {value: "AZ", label: "AZ"},
    {value: "AR", label: "AR"},
    {value: "CA", label: "CA"},
    {value: "CO", label: "CO"},
    {value: "CT", label: "CT"},
    {value: "DE", label: "DE"},
    {value: "FL", label: "FL"},
    {value: "GA", label: "GA"},
    {value: "HI", label: "HI"},
    {value: "ID", label: "ID"},
    {value: "IL", label: "IL"},
    {value: "IN", label: "IN"},
    {value: "IA", label: "IA"},
    {value: "KS", label: "KS"},
    {value: "KY", label: "KY"},
    {value: "LA", label: "LA"},
    {value: "ME", label: "ME"},
    {value: "MD", label: "MD"},
    {value: "MA", label: "MA"},
    {value: "MI", label: "MI"},
    {value: "MN", label: "MN"},
    {value: "MS", label: "MS"},
    {value: "MO", label: "MO"},
    {value: "MT", label: "MT"},
    {value: "NE", label: "NE"},
    {value: "NV", label: "NV"},
    {value: "NH", label: "NH"},
    {value: "NJ", label: "NJ"},
    {value: "NM", label: "NM"},
    {value: "NY", label: "NY"},
    {value: "NC", label: "NC"},
    {value: "ND", label: "ND"},
    {value: "OH", label: "OH"},
    {value: "OK", label: "OK"},
    {value: "OR", label: "OR"},
    {value: "PA", label: "PA"},
    {value: "RI", label: "RI"},
    {value: "SC", label: "SC"},
    {value: "SD", label: "SD"},
    {value: "TN", label: "TN"},
    {value: "TX", label: "TX"},
    {value: "UT", label: "UT"},
    {value: "VT", label: "VT"},
    {value: "VA", label: "VA"},
    {value: "WA", label: "WA"},
    {value: "WV", label: "WV"},
    {value: "WI", label: "WI"},
    {value: "WY", label: "WY"}
];
const validatePasswordBooleanObject = (password, username = '', lastUsedPasswords = [], confirmPassword = '') => {
    const validations = {
        hasLowerUpperCaseAndNumberSpecialChar: false,
        hasLength: false,
        hasRepeatedOrSequential: false,
        hasUsername: false,
        hasLast6UsedPassword: false,
        hasConfirmPassword: false,
    };

    // Criteria 1: Minimum length of 8 characters
    if (password.length < 8) {
        validations.hasLength = true;
    }

    // Criteria 2: At least one character of each group
    const hasLowerCase = /[a-z]/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (!hasLowerCase || !hasUpperCase || !hasNumber || !hasSpecialChar) {
        validations.hasLowerUpperCaseAndNumberSpecialChar = true;
    }

    // Criteria 3: Not allow 3 repeated or sequential characters
    const repeatedOrSequential = /(.)\1\1|012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba|210|321|432|543|654|765|876|987|098/i;
    if (repeatedOrSequential.test(password)) {
        validations.hasRepeatedOrSequential = true;
    }

    // Criteria 4: Not allow portions of the username
    const lowerUsername = username.toLowerCase();
    const lowerPassword = password.toLowerCase();
    for (let i = 0; i <= lowerUsername.length - 3; i++) {
        if (lowerPassword.includes(lowerUsername.substring(i, i + 3))) {
            validations.hasUsername = true;
        }
    }

    // Criteria 5: Not allow the password to be the same from the last 6 used passwords
    if (lastUsedPasswords != null && lastUsedPasswords.includes(password)) {
        validations.hasLast6UsedPassword = true;
    }

    // Criteria 6: Check Confirm Password
    if (confirmPassword != '' && confirmPassword != password) {
        validations.hasConfirmPassword = true;
    }
  
    return validations;
};

const TIMEZONE_MAP = {
    PT: "America/Los_Angeles",
    ET: "America/Detroit",
    CT: "America/Chicago",
    MT: "America/Denver",
    AKT: "US/Alaska",
    HT: "Pacific/Honolulu",
    AZ: "America/Phoenix",
    CET: "Europe/Amsterdam",
    EU_LONDON: 'Europe/London',
    EU_BERLIN: 'Europe/Berlin',
    EU_ATHENS: 'Europe/Athens',
    EU_MOSCOW: 'Europe/Moscow',
    EU_ISTANBUL: 'Europe/Istanbul',
    EU_MINSK: 'Europe/Minsk',
    EU_SAMARA: 'Europe/Samara',
    EU_YEKATERINBURG: 'Asia/Yekaterinburg',
};

export {
    patternEmail,
    patternPassword,
    patternDate,
    patternFloatValue,
    patternTimeValue,
    patternYear,
    patternNumericValue,
    imageExtention,
    csvExtention,
    patternNumericTenDigitsValue,
    patternNumericData,
    patternPhone,
    validatePassword,
    validatePasswordBooleanObject,
    validateObjectNull,
    patternGetNameExtension,
    mimeTypes,
    CLOTHING_SIZES,
    SHOW_SIZES,
    USA_STATES,
    TIMEZONE_MAP
};
